var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
var Spinner = function (_a) {
    var value = _a.value;
    var additionalProps = useMemo(function () {
        if (typeof value === 'undefined') {
            return {};
        }
        return {
            variant: 'determinate',
            value: value,
        };
    }, [value]);
    return React.createElement(CircularProgress, __assign({}, additionalProps));
};
export default Spinner;
